import React from 'react';
import { Field, Form, FormController } from 'core/cells/forms';
import { FormTextField } from 'core/cells/form-text-field';
import { FlexBox } from 'core/cells/box';

import { Button } from 'templates/mdp/components/custom-buttons';

import { JournalType } from 'core/dna/types/generated/_globalTypes';
import { useTranslations } from 'core/dna/translations';
import { useStudentsTableWrite } from '../use-students-table-write';

interface Values {
  note: string;
}

interface JournalNoteProps {
  tuid: string | null;
  setOpen: (open: boolean) => void;
  resetJournalType: (selectedType: JournalType | null) => void;
}

export const JournalNote = ({
  tuid,
  setOpen,
  resetJournalType,
}: JournalNoteProps) => {
  const { texts } = useTranslations();
  const { onCreateJournalEntry } = useStudentsTableWrite();

  return (
    <FormController
      initialValues={{
        note: '',
      }}
      validate={(values) => {
        const errors: Partial<Values> = {};
        if (!values.note) {
          errors.note = texts.oasCommon.validation.required;
        }
        return errors;
      }}
      onSubmit={async (values) => {
        if (!tuid) return;
        await onCreateJournalEntry({
          regardingTuid: tuid,
          type: JournalType.note,
          data: { [JournalType.note]: values.note },
        });
        setOpen(false);
        resetJournalType(null);
      }}
    >
      {({ submitForm, isSubmitting }) => (
        <Form>
          <Field
            component={FormTextField}
            name="note"
            type="text"
            label={texts.planner.common.notes.one}
            disabled={isSubmitting}
            fullWidth
            multiline
            rows={2}
            rowsMax={5}
          />
          <FlexBox justifyContent="flex-end">
            <Button
              color="secondary"
              disabled={isSubmitting}
              onClick={submitForm}
            >
              {texts.planner.common.save}
            </Button>
            <Button
              color="secondary"
              simple
              onClick={() => {
                setOpen(false);
              }}
            >
              {texts.planner.common.close}
            </Button>
          </FlexBox>
        </Form>
      )}
    </FormController>
  );
};
